import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { useParams } from 'react-router';
import { companyStateLoadable } from '../../../../../../services/state/CompanyStateJ';
import { kpisRequestsMapByIdStateLoadableJ } from '../../../../../../services/state/KPI/KPIRequestsStateJ';
import { kpiTemplatesListStateLoadableJ } from '../../../../../../services/state/KPI/KPITemplatesStateJ';
import { sanitizeAsFileName } from '../../../../../../util/stringUtils';

export function useResponseFileName() {
  const { requestId } = useParams();
  const requestsMapLoadable = useAtomValue(kpisRequestsMapByIdStateLoadableJ);
  const request =
    requestsMapLoadable.state === 'hasData' ? requestsMapLoadable.data.get(Number(requestId)) : undefined;
  const companyLoadable = useAtomValue(companyStateLoadable(request?.companyId ?? -1));
  const companyName = companyLoadable.state === 'hasData' ? companyLoadable.data?.name : undefined;
  const templatesLoadable = useAtomValue(kpiTemplatesListStateLoadableJ);
  const template =
    templatesLoadable.state === 'hasData'
      ? templatesLoadable.data?.find((t) => request?.templateId == t.id)
      : undefined;

  return useCallback(
    (fieldTitle: string, originalFileName?: string) => {
      if (!request || !template) {
        return originalFileName ?? fieldTitle;
      }
      return sanitizeAsFileName(
        `${companyName}_${fieldTitle ?? template.name}${originalFileName ? `_${originalFileName}` : ''}_${request.period}`
      );
    },
    [companyName, request, template]
  );
}
